module.exports = __webpack_public_path__ + "media/flags/at-67858e80.svg";